import React from 'react';
import router from 'next/router';
import styles from '../../../styles/pages/SinglePost.module.scss';
import parser, { HTMLReactParserOptions, domToReact } from 'html-react-parser';
import useResponsive from '../../../utils/hooks/useResponsive';
import useAuthenticated from '../../../utils/hooks/useAuthenticated';
import { BottomNavigation } from '@lifepal/lifepal-design-system';
import useWebView from '../../../utils/hooks/useWebView';

import { NORMAL_MENU, LOGIN_MENU, ACCOUNT_PROPS, INSURANCE_LINKS, TOOLS_PROPS, EXPLORE_PROPS } from '../../../lib/bottomNavConstant';

const Page = ({ page }) => {
  const authenticated = useAuthenticated();
  const { isDesktop } = useResponsive();
  const isWebView = useWebView();

  const aboutPageOptions: HTMLReactParserOptions = {
    replace: ({ attribs, children }: any) => {
      if (attribs && attribs.class) {
        if (attribs.class.includes('row')) {
          return <div className={styles['section']}>{domToReact(children, aboutPageOptions)} </div>
        }

        if (attribs.class.includes('col-3 col-md-1 mb-4')) {
          return <div className={styles['small__img']}>{domToReact(children, aboutPageOptions)} </div>
        }

        if (attribs.class.includes('col-9 col-md-3')) {
          return <div className={styles['small__text']}>{domToReact(children, aboutPageOptions)} </div>
        }
      }
    }
  };

  return (
    <>
      <div
        className={styles['single-page__wrapper']}
        dangerouslySetInnerHTML={{ __html: page.content }}
      />

      {!isDesktop && authenticated && !isWebView && (
        <BottomNavigation
          activePath={router.asPath}
          isLoggedIn={authenticated}
          normalMenu={NORMAL_MENU} //menu when user isn't logged in TODO: fix
          loginMenu={LOGIN_MENU}
          accountProps={ACCOUNT_PROPS} //props for Account section in normal menu
          insuranceLinks={INSURANCE_LINKS}
          toolsProps={TOOLS_PROPS}
          exploreProps={EXPLORE_PROPS}
        />
      )}
    </>
  );
};

export default Page;
